import Image from 'app/Components/Shared/Image/image';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import React from 'react';
import RouterActivationWizardFrontPageBlockData from 'app/Models/Content/RouterActivationWizardFrontPageBlockData';
import BtnSubmit  from '../../Shared/Buttons/BtnSubmit';

const RouterActivationWizardFrontPageBlock = ({data, context}: ComponentProps<RouterActivationWizardFrontPageBlockData>) => {
  
  const navigateToWizard = () => {
    context.navigateTo(data.routerActivationPageLink.value);
  };

  return (
    <div className='router-activation-front-page'>
        <div className='router-activation-front-page-title'>{data.title.value}</div>
        <div className='router-activation-front-page-img'><Image src={context.getEpiserverUrl(data.image.expandedValue.url)} height='200' width='350' /></div>
        <div className='router-activation-front-page-text'>{data.subtitle.value}</div>
        <div className='router-activation-front-page-text-pink'>{data.processDescription1.value}</div>
        <div className='router-activation-front-page-text-pink'>{data.processDescription2.value}</div>
        <div className='router-activation-front-page-text-pink'>{data.processDescription3.value}</div> 
        <div className='router-activation-front-page-button'><BtnSubmit text="כן, הסופר ראוטר הגיע" onclick={navigateToWizard}/></div>
        <div style={{textAlign:'center'}}><a className='router-activation-front-page-link' href={data.loginPageLink.value}>הסופר ראוטר לא הגיע. לא להפעיל</a></div>
    </div>
  );
};

export default RouterActivationWizardFrontPageBlock;